import { PageLayout } from '@ui/components/layouts';
import { text as navbarText } from '@modules/navbar/text';
import { text as settingsText } from '@modules/settings/text';

import { useAuthActions } from '@convex-dev/auth/react';
import { GardenPreferences } from '@modules/garden-preferences/views/garden_preferences_view';
import { SettingsContainer } from '@modules/settings/containers/settings_container';
import { Settings } from '@modules/settings/views/settings_view';

import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { webAppRoutes } from '@/src/lib/navigation/containerPaths';

export function SettingsScreen() {
  const navigate = useNavigate();
  const { signOut } = useAuthActions();

  const handleSignOut = useCallback(async () => {
    await signOut();
    navigate('/login', { replace: true });
  }, [navigate, signOut]);

  const handleChangePassword = useCallback(() => {
    navigate(webAppRoutes.changePassword);
  }, [navigate]);

  return (
    <PageLayout title={navbarText.settings} description={settingsText.subtitle} maxWidth={896}>
      <SettingsContainer
        View={Settings}
        onChangePassword={handleChangePassword}
        onSignOut={handleSignOut}
      />

      <GardenPreferences />
    </PageLayout>
  );
}
